import { render, staticRenderFns } from "./searchIdName.vue?vue&type=template&id=06933f2a&"
import script from "./searchIdName.vue?vue&type=script&lang=js&"
export * from "./searchIdName.vue?vue&type=script&lang=js&"
import style0 from "./searchIdName.vue?vue&type=style&index=0&id=06933f2a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports